import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import { moneyAccurate as money } from 'app/helpers/money';
import { useContext } from './useFormContext';

const TransactionLimits: FC<{
  minTnx: number;
  isMinTnxViolated: boolean;
  maxTnx: number;
  isTaxTnxViolated: boolean;
  vendorCurrency: string;
}> = ({ minTnx, isMinTnxViolated, maxTnx, isTaxTnxViolated, vendorCurrency }) => {
  const { locales } = useContext();

  return (
    <div className="transaction-limits">
      <div id="transaction-limits-label">
        <div className="rs-column-small-12">{`${locales.transaction_limits_label}:`}</div>
      </div>
      <div className="rs-flex rs-gap_small__zero limits" aria-labelledby="transaction-limits-label">
        <div className={classnames({ error: isMinTnxViolated }, 'rs-flex-item rs-medium-6 min')}>
          {locales.min_transaction} &nbsp;
          <span className="value">{money(minTnx, vendorCurrency)}</span>
        </div>
        <div className={classnames({ error: isTaxTnxViolated }, 'rs-flex-item rs-medium-6 max')}>
          {locales.max_transaction} &nbsp;
          <span className="value">{money(Number.isFinite(maxTnx) ? maxTnx : 0, vendorCurrency)}</span>
        </div>
      </div>
    </div>
  );
};

export default TransactionLimits;
